import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchNextQuoteNumber } from '../query-api'

export const useFetchNextQuoteNumber = () => {
  const { data: nextQuoteNumberData, ...rest } = useQuery(QueryKeys.NextQuoteNumber, () => fetchNextQuoteNumber())

  return { nextQuoteNumber: nextQuoteNumberData?.data?.invoicenumber, ...rest }
}
